import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "topic list-unstyled row mx-0 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<div class=\"skeleton\"><div class=\"d-flex flex-row-reverse align-items-center\"><div class=\"skeleton-avatar mb-0\"></div><div class=\"d-flex flex-column flex-fill\"><div class=\"skeleton-title mb-0 me-3 w-50\"></div><div class=\"skeleton-title mb-0 me-5 mt-2\"></div></div></div></div>", 1)
  ]))]))
}